import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from 'components/Typography';
import Chevron from '@alltrails/shared/icons/Chevron';
import heartSrc from 'components/icons/heart.svg';
import Link from 'components/Link';
import logInviteFriendsBannerClicked from '@alltrails/analytics/events/logInviteFriendsBannerClicked';
import InviteFriendsBannerSource from '@alltrails/analytics/enums/InviteFriendsBannerSource';
import * as styles from './InviteYourFriendsBannerMobile.module.scss';

// https://app.zeplin.io/project/62193b4e4e72bf62a25f2093/screen/62193c4127fbf063768a2284

export default function InviteYourFriendsBannerMobile() {
  return (
    <div className={styles.banner}>
      <img alt="" className={styles.heart} src={heartSrc} />
      <div className={styles.content}>
        <Typography component="div" variant="headline2">
          <FormattedMessage defaultMessage="Invite your friends" />
        </Typography>
        <Typography component="div" variant="body3">
          <FormattedMessage defaultMessage="Once they join, we’ll plant a tree for each of you" />
        </Typography>
      </div>
      <Link
        href="/refer"
        onClick={() => {
          logInviteFriendsBannerClicked({ source: InviteFriendsBannerSource.Homepage });
        }}
        variant="secondary"
      >
        <Chevron orientation="right" size="sm" />
      </Link>
    </div>
  );
}
